import { render, staticRenderFns } from "./audio-component.vue?vue&type=template&id=4d087676&scoped=true"
import script from "./audio-component.vue?vue&type=script&lang=js"
export * from "./audio-component.vue?vue&type=script&lang=js"
import style0 from "./audio-component.vue?vue&type=style&index=0&id=4d087676&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d087676",
  null
  
)

export default component.exports